import { Modal } from "reactstrap";
import React, { useEffect } from "react";
import {
  Button,
  Col as ColAnt,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
} from "antd";
import { connect } from "react-redux";
import {
  loadSubscription,
  updateSubscription,
} from "../../../store/financialSettings/actions";
import { currencyOptions } from "../../../helpers/financial_settings_helper";

const EditSubscription = ({
  subscriptionId,
  subscription,
  loadSubscription,
  updateSubscription,
  open,
  onCancel,
  isLoading,
}) => {
  const [form] = Form.useForm();
  useEffect(() => {
    // if current subscription id is missing, skip
    if (!subscriptionId) {
      return;
    }
    // if fee is loaded, skip
    if (subscription && subscription.id === subscriptionId) {
      return;
    }
    loadSubscription(subscriptionId);
  }, [subscriptionId, subscription, loadSubscription]);

  useEffect(() => {
    if (!subscription || isLoading) {
      return;
    }
    const id = form.getFieldValue("id");
    if (id && id === subscriptionId) {
      return;
    }
    console.log("setting subscription", subscription);
    form.setFieldsValue(subscription);
  }, [subscription, isLoading, form, subscriptionId]);

  const onFinish = async (formData) => {
    try {
      const subscription = {
        ...formData,
        validFrom: formData.validFrom ? formData.validFrom.toDate() : null,
        validTo: formData.validTo ? formData.validTo.toDate() : null,
      };
      updateSubscription(subscription);
    } catch (err) {
      console.log(err?.response);
    }
  };
  const onFinishFailed = async (formData) => {
    console.log("on finish failed", formData);
  };

  return (
    <Modal isOpen={open} toggle={onCancel}>
      <div className="modal-header">
        <h5 className="modal-title mt-0">Редактиране на абонамент</h5>
        <button
          type="button"
          onClick={() => {
            return onCancel();
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <Form
          disabled={!subscription || isLoading}
          form={form}
          className="editing-form editing-form-steps"
          layout="vertical"
          name="transactionFee"
          autoComplete="on"
          initialValues={subscription}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <ColAnt xs={24}>
            <Form.Item noStyle name="id">
              <Input type="hidden" />
            </Form.Item>
            <Form.Item
              name="feeAmount"
              label="Сума"
              rules={[
                {
                  required: true,
                  message: "Сумата за абонамент трябва да е по-голяма от 0",
                  type: "number",
                  min: 0.1,
                },
              ]}
            >
              <InputNumber
                placeholder="Сума"
                changeOnWheel
                min={0}
                size="middle"
                type="number"
              />
            </Form.Item>
            <Form.Item name="currency" label="Валута">
              <Select
                value="BGN"
                aria-readonly="true"
                options={currencyOptions}
                disabled
              ></Select>
            </Form.Item>
            <Form.Item
              name="validFrom"
              label={"Валиден от"}
              className="input-box"
              rules={[
                {
                  type: "date",
                },
              ]}
            >
              <DatePicker className="input" format={"DD.MM.YYYY"} />
            </Form.Item>
            <Form.Item
              name="validTo"
              label={"Валиден до"}
              className="input-box"
              rules={[
                {
                  type: "date",
                },
              ]}
            >
              <DatePicker className="input" format={"DD.MM.YYYY"} />
            </Form.Item>
          </ColAnt>
          <Form.Item>
            <Button htmlType="submit" className="" disabled={isLoading}>
              Обнови
            </Button>
          </Form.Item>
        </Form>
      </div>

      {isLoading && (
        <div className="modal-footer">
          <div className="spinner-border text-success m-1" role="status">
            <span className="sr-only">Зареждане...</span>
          </div>
        </div>
      )}
    </Modal>
  );
};
const mapStateToProps = ({
  FinancialSettings: {
    currentSubscriptionId,
    subscription,
    isLoadingSubscription,
  },
}) => {
  return {
    subscriptionId: currentSubscriptionId,
    subscription,
    isLoading: isLoadingSubscription,
  };
};

export default connect(mapStateToProps, {
  updateSubscription,
  loadSubscription,
})(EditSubscription);
